import axiosInstance from 'helpers/axiosInstance';

import { PatientConsult } from './types/consults.types';

export const getConsultsForPatient = (
  patientId: string | undefined | unknown,
) => {
  return axiosInstance
    .get<{ patientConsults: PatientConsult[] }>(
      `/patients/patient_consults?includes[]=survey_responses&includes[]=patient&includes[]=rx_orders&includes[]=therapy_recommendations&patient_id=${patientId}`,
    )
    .then(d => d.data.patientConsults);
};
